export type Option = {
  id?: string
  type?: string
  name?: string
  visible?: boolean
  style: string
  // 区域边界点集，
  path: {
    points: { position: [number, number, number] }[]
    corner: number
    close: boolean
  }
  fence: FenceOption
  fillArea?: FillAreaOption
  // 是否自动贴地
  surfaceSnap?: boolean
  // 位置类型
  posType?: number
  // Z坐标类型
  coordZType?: number
}
export type FenceOption = {
  height: number
  color: string
  alpha: number
  uri?: string
  visible?: boolean
  corner?: number
  close?: boolean
  points?: [number, number, number]
}

export type FillAreaOption = {
  color: string
  alpha: number
  pos?: string
  corner?: number
  close?: boolean
  points?: [number, number, number]
  uri?: string
  visible?: boolean
}